
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sveden/[slug]",
      function () {
        return require("private-next-pages/sveden/[slug]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sveden/[slug]"])
      });
    }
  